module.exports = __webpack_public_path__ + "media/assets/images/common/logo-vertical-0a06d5745010b8126ab68143cf4084ef.png";